import cn from 'classnames'

import ReactHtmlParser from 'react-html-parser'

import styles from './styles.module.scss'
import OpenIcon from './icons/iconOpen.svg'
import CloseIcon from './icons/iconClose.svg'
import { ExchangeQuestionProps } from './exchange-question.props'

export default function ExchangeQuestion({ currentId, questionId, handleOpen, question }: ExchangeQuestionProps) {
  return (
    <div className={styles.question}>
      <div
        className={cn(styles.question__title, { [styles.question__title_opened]: currentId === questionId })}
        onClick={handleOpen}
      >
        <h3>{question.title}</h3>
        <img src={currentId === questionId ? OpenIcon : CloseIcon} alt="eye icon" />
      </div>
      <p className={cn(styles.text, { [styles.opened]: currentId === questionId })}>
        {ReactHtmlParser(question.answer)}
      </p>
    </div>
  )
}
